import React from 'react';
import { useQuery } from 'react-query';
import api from '../services/api';

/**
 * Read-only display of saved custom fields for an entity.
 * Skips fields with no value.
 */
const CustomFieldsDisplay = ({ entity, values, wrapperClassName, renderWrapper }) => {
  const { data: defs = [] } = useQuery(
    ['custom-fields', entity],
    () => api.get('/custom-fields', { params: { entity } }).then((r) => r.data),
    { staleTime: 60 * 1000 }
  );

  // Accept Map from API (serialized as plain object) or direct object
  const valueMap = values instanceof Map
    ? Object.fromEntries(values)
    : (values || {});

  const populated = defs
    .map((def) => ({ def, value: valueMap[def.key] }))
    .filter(({ value }) => value !== undefined && value !== null && value !== '');

  if (populated.length === 0) return null;

  const formatValue = (def, v) => {
    if (def.type === 'checkbox') return v ? 'Yes' : 'No';
    if (def.type === 'date') return v ? new Date(v).toLocaleDateString() : '';
    if (def.type === 'number') return typeof v === 'number' ? v.toLocaleString() : v;
    return String(v);
  };

  // The wrapper (box, border, spacing, or a whole card via renderWrapper)
  // lives here so callers never paint an empty box for records whose
  // customFields only hold internal keys (e.g. Phone Agent tasks/notes
  // carry phone_agent, vapi_call_id…; Meta leads carry profile_pic).
  const list = (
    <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 text-sm">
      {populated.map(({ def, value }) => (
        <div key={def._id}>
          <dt className="text-xs text-gray-500">{def.label}</dt>
          <dd className="text-gray-900 mt-0.5 break-words">{formatValue(def, value)}</dd>
        </div>
      ))}
    </dl>
  );
  if (renderWrapper) return renderWrapper(list);
  return wrapperClassName ? <div className={wrapperClassName}>{list}</div> : list;
};

export default CustomFieldsDisplay;
